import React from 'react';
import Image from './InfographicImage';
import Tooltip from './Tooltip';
import Fade from 'react-reveal/Fade';

import '../stylesheets/Infographic.scss';

export default function Infographic(props) {
  function printHeader() {
    return props.copy
      .filter((val) => val.section === props.sectionNumber)
      .map((val) => {
        return (
          <header key={val.section}>
            {val.title}
            {val.subhead}
          </header>
        );
      });
  }

  function renderImages(images) {
    return images.map((image, index) => {
      return (
        <div className="image-wrapper" key={image.image}>
          {image.animation ? (
            <Fade
              delay={500 * index}
              distance={image.distance ? image.distance : false}
              top={image.direction ? image.direction[0] : false}
              right={image.direction ? image.direction[1] : false}
              bottom={image.direction ? image.direction[2] : false}
              left={image.direction ? image.direction[3] : false}
            >
              {image.tooltip ? (
                <Tooltip position={'top'} x={props.x} y={props.y} link={props.link} popup={props.popup} popupId={props.popupId}>
                  <img src={image.image} alt="infographic statistic" />
                </Tooltip>
              ) : (
                <Image image={image.image} />
              )}
            </Fade>
          ) : image.tooltip ? (
            <Tooltip position={'top'} x={props.x} y={props.y} link={props.link} popup={props.popup} popupId={props.popupId}>
              <img src={image.image} alt="infographic statistic" />
            </Tooltip>
          ) : (
            <Image image={image.image} />
          )}
        </div>
      );
    });
  }

  function renderAllImages() {
    if (window.innerWidth > 1024) {
      return renderImages(props.images);
    } else {
      if (props.laptopImages) {
        return renderImages(props.laptopImages);
      } else {
        return renderImages(props.images);
      }
    }
  }

  return (
    <div className="infographic-container" id={props.sectionName}>
      {printHeader()}
      {props.sectionNumber !== 1 && (
        <div className="infographic-key">
          <h3 className="blue">Millennials</h3>
          <h3 className="pink">Gen&nbsp;X</h3>
          <h3 className="yellow">Boomers</h3>
        </div>
      )}

      <section className="image-section">{renderAllImages()}</section>
    </div>
  );
}
